import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export class LensService {

  private data$ = new BehaviorSubject<string>(null);
  materialCode = this.data$.asObservable();
  visionTypeCode = this.data$.asObservable();

  public getMaterialCode(): Observable<string> {
    return this.materialCode;
  }

  public setMaterialCode(materialCode: string){
    this.data$.next(materialCode);
  }

  public getVisionTypeCode(): Observable<string> {
    return this.visionTypeCode;
  }
  public setVisionTypeCode(visionTypeCode: string) {
    this.data$.next(visionTypeCode);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/lens/lens.service.ts